import { GoodsHolderLink } from '../../common/components/links/Links'
import {
  bool,
  capitalize,
  date,
  measure,
  plannedAndActualPackedQuantity,
} from '../../common/utils/formatter'
import { TTExceptionsIndicator } from '../shipment/ShipmentsTableIndicators'

export const goodsHoldersTableColumns = [
  {
    Header: ' ',
    accessor: 'ttExceptions',
    Cell: (e) => <TTExceptionsIndicator ttExceptions={e.value} />,
  },
  {
    Header: 'Nike ID',
    accessor: 'goodsHolderNumber',
    Cell: (ghn) => <GoodsHolderLink goodsHolderNumber={ghn.value} />,
  },
  { Header: 'Tracking Number', accessor: 'goodsHolderTrackingNumber' },
  { Header: 'CMR', accessor: 'transportHolder.proNumber' },
  { Header: 'Trailer', accessor: 'transportHolder.transportHolderNumber' },
  { Header: 'CMR Date', accessor: (gh) => date(gh.transportHolder?.cmrTimestamp) },
  { Header: 'PO Number', accessor: 'purchaseOrderNumber' },
  { Header: 'Trailer Access Number', accessor: 'transportHolder.vendorAccessNumber' },
  { Header: 'Status', accessor: (gh) => capitalize(gh.calculatedGoodsHolderStatusCode) },
  { Header: 'Delivery Date', accessor: (gh) => date(gh.actualDeliveryDate) },
  {
    Header: 'Weight',
    accessor: (gh) => measure(gh.goodsHolderMeasures?.grossWeight),
  },
  {
    Header: 'Volume',
    accessor: (gh) => measure(gh.goodsHolderMeasures?.grossVolume),
  },
  {
    Header: '# Units (P/A)',
    accessor: (goodsHolder) => plannedAndActualPackedQuantity(goodsHolder),
  },
  { Header: 'Direct Drop', accessor: (gh) => bool(gh.transportHolder?.directDropIndicator) },
]
